import React, { createContext, useContext, useEffect, useState } from 'react';
import { AppContext } from '../../contexts/AppContext';
import FeedbackContainer from './FeedbackContainer';

export const FeedbackContext = createContext({
  open: false,
  isStoreFeedback: false,
  handleOpenFeedbackModal: () => {},
});

const isServer = typeof window === 'undefined';

function HideFeedbackChat() {
  const context = useContext(AppContext);
  useEffect(() => {
    const hideChatCheckoutIntl = () => {
      if ($('#layoutCheckout').length > 0 && context.state.country !== 'US') {
        if ($('.desktopPage').length > 0 || $('.tabletPage').length > 0) {
          const el = document.getElementById('feedback-footer-button-international');
          if (el) {
            el.innerHTML = 'Site Feedback';
          }
        } else {
          const el = document.getElementById('feedback-footer-button');
          if (el) {
            el.innerHTML = 'Site Feedback';
          }
        }
      }
    };
    if (!isServer) {
      if ($('.card.active#step2').length) {
        const el = document.getElementById('feedback-footer-button');
        el.innerHTML = 'Site Feedback';
      }
      hideChatCheckoutIntl();
    }
  }, []);
}

export const FeedbackProvider = ({ children, hideContainer }) => {
  const [open, setOpen] = useState(false);
  const [isStoreFeedback, setIsStoreFeedback] = useState(false);

  function handleOpenFeedbackModal(e, isStoreFeedback) {
    setIsStoreFeedback(isStoreFeedback === 'storePage');
    setOpen((open) => !open);
  }

  return (
    <FeedbackContext.Provider value={{ open, isStoreFeedback, handleOpenFeedbackModal }}>
      <HideFeedbackChat />
      {<FeedbackContainer hideContainer={hideContainer} />}
      {children}
    </FeedbackContext.Provider>
  );
};
